const seperator = '_';

export const participantName = (identityCode) => {
  const seperatorIndex = identityCode.indexOf(seperator) + 1;
  const name = identityCode.substr(0, seperatorIndex - 1);
  const userId = identityCode.substring(seperatorIndex);
  const tagHandle = identityCode.replace(' ', '').toLowerCase();
  return { name, userId, tagHandle };
};

const generateTagHandle = (name, userId) => {
  const removedSpace = name.replace(' ', '').toLowerCase();
  const tagHandle = `@${removedSpace}_${userId}`;
  return tagHandle;
};

export const isSameUser = (actualIdentity, msgIdentity) => {
  return +msgIdentity === +actualIdentity;
};

export const isATaggedMsg = (name, userId, textMsg) => {
  const tagHandle = generateTagHandle(name, userId);

  return textMsg.includes(tagHandle);
};
